/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the _value_ of an environment value is `undefined`
 * @export
 * @class EnvUnparseableJsonError
 * @extends {Error}
 */
export class EnvUnparseableJsonError extends Error {
  /**
   * Creates an instance of EnvUnparseableJsonError
   * @param {string} message The Error `message`
   * @memberof EnvUnparseableJsonError
   */
  constructor(message) {
    super(message);
    this.name = `EnvUnparseableJsonError`;
  }
}

/**
 * Called when the _value_ of an environment value is `undefined`
 * @param {string} key The `key` pointing to the invalid value
 * @param {any} value The invalid JSON
 * @param {Error} error The caught Error
 * @returns {never} never
 */
const throwEnvUnparseableJsonError = (key, value, error) => {
  throw new EnvUnparseableJsonError(
    stripIndent(`
    Could not "JSON.parse" the environment variable "${key}".
    The "value" extracted was invalid JSON
    Got: "${value}"

    Experienced:
    ${error.stack}
    `),
  );
};

export default throwEnvUnparseableJsonError;
